class VeridzEdit extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    const tabs = this.querySelector('[data-edit-tabs]');
    const buttons = [...tabs.querySelectorAll('button')];
    const panels = [...this.querySelectorAll('[data-edit-panel]')];
    tabs.hidden = false;
    tabs.setAttribute('role', 'tablist');
    const activate = (button, focus = false) => {
      buttons.forEach(b => { const active = b === button; b.setAttribute('aria-selected', String(active)); b.tabIndex = active ? 0 : -1; });
      panels.forEach(p => { p.hidden = p.dataset.editPanel !== button.dataset.edit; });
      if (focus) button.focus();
    };
    buttons.forEach((button, i) => {
      const panel = panels.find(p => p.dataset.editPanel === button.dataset.edit);
      button.id = `${panel.id}-tab`;
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-controls', panel.id);
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', button.id);
      button.addEventListener('click', () => activate(button));
      button.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (i + 1) % buttons.length;
        if (event.key === 'ArrowLeft') next = (i + buttons.length - 1) % buttons.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = buttons.length - 1;
        if (next !== undefined) { event.preventDefault(); activate(buttons[next], true); }
      });
    });
    activate(buttons[0]);
  }
}
class VeridzPair extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.form = this.querySelector('form');
    this.button = this.querySelector('button[type="submit"]');
    this.message = this.querySelector('[data-pair-message]');
    this.selects = [...this.querySelectorAll('[data-pair-variant]')];
    this.form.addEventListener('change', () => this.updateTotal());
    this.form.addEventListener('submit', event => this.addPair(event));
  }
  updateTotal() {
    this.selects.forEach(select => {
      const option = select.selectedOptions[0];
      if (option.value) select.closest('.vz-pair__item').querySelector('[data-item-price]').textContent = option.dataset.money;
    });
    if (this.selects.every(s => s.value)) {
      const total = this.selects.reduce((sum, s) => sum + Number(s.selectedOptions[0].dataset.price), 0);
      this.querySelector('[data-pair-total]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:this.dataset.currency || 'USD'}).format(total / 100);
    }
  }
  async addPair(event) {
    event.preventDefault();
    if (this.busy || !this.form.reportValidity()) return;
    this.busy = true;
    this.button.disabled = true;
    this.button.setAttribute('aria-busy', 'true');
    this.message.textContent = 'Adding your two pieces…';
    this.querySelector('.vz-pair__recover').hidden = true;
    const drawer = document.querySelector('cart-drawer');
    const sectionIds = drawer?.getSectionsToRender().map(s => s.id) || [];
    const items = this.selects.map(s => ({id: Number(s.value), quantity: 1}));
    try {
      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({items, sections:sectionIds, sections_url:window.location.pathname})
      });
      const data = await response.json();
      if (!response.ok || data.status) {
        this.message.textContent = typeof data.description === 'string' ? data.description : 'An item is no longer available in your chosen options. Review your bag and selections.';
        this.querySelector('.vz-pair__recover').hidden = false;
        return;
      }
      this.message.textContent = 'Both pieces added to your bag.';
      if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, {source:'veridz-pair', cartData:data});
      if (drawer && sectionIds.every(id => data.sections?.[id])) {
        drawer.setActiveElement(this.button);
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
      } else { window.location.assign(window.routes.cart_url); }
    } catch (error) {
      // Do not retry an uncertain POST: the first request may already have added items.
      this.message.textContent = 'We could not confirm the update. Check your bag before trying again.';
      this.querySelector('.vz-pair__recover').hidden = false;
    } finally {
      this.busy = false;
      this.button.disabled = false;
      this.button.removeAttribute('aria-busy');
    }
  }
}
if (!customElements.get('veridz-edit')) customElements.define('veridz-edit', VeridzEdit);
if (!customElements.get('veridz-pair')) customElements.define('veridz-pair', VeridzPair);
